export default {
  title: {
    name: 'Midea H5'
  },
  mxTitle: 'Midea Connect',
  mxLongContent: 'MideaConnect grows with you',
  locale: 'English',
  help: 'Help and feedback',
  welcome: "welcome",
  downloadNow: 'Download',
  netError: 'Network anomaly, please try again later',
  codeLargeTip: '（You can click to enlarge and view the download QR code）',
  ok: 'OK',
  clickRightTopIOS: 'Click here and open in safari',
  clickRightTopAndroid: 'Click on the menu in the top right corner, and open in the browser',
  mx: {
    introduce: 'Midea Connect is a communication & cooperation application for the Midea employees. It contains chat communication, video conferencing, document sharing, mini-program and other services, facilitating efficient communication and collaboration between employees.',
    downTips: 'Download MideaConnect client',
    ios: 'iOS',
    android: 'Android & HarmonyOS',
    mac: 'macOS',
    window: 'Windows',
    downloadClick: 'Click to download',
    downloadScan: 'Scan to download',
    scanCodeDown: 'Scan QR code to download'
  },
  vpn: {
    title: 'Midea VPN',
    introduce: 'VPN is a network tool used internally by Midea Group, which can assist employees in remote work scenarios such as working from home, business trips, etc., improving work efficiency.',
    tips: 'Long press to save to the album or scan the QR code to download',
    downTips: 'Download VPN',
    configureSeq: 'Installation Guide',
    configureDownload: 'Configuration File',
    pcCoreAliens: 'switch to China overseas version',
    pcCoreZH: 'switch to China domestic version',
    iphoneCoreAliens: 'Download overseas version',
    iphoneCoreZH: 'Download China domestic version',
    downloadAliens: 'Scan to download',
    downloadZH: 'Scan to download',
  },
  MacDownload: {
    title: 'Download the version of Midea Connect that is more suitable for your Mac',
    text1: 'Midea Connect has been optimized for both Mac computers using Intel chips and those using Apple chips. Using the correct version can help reduce resource consumption and improve software performance.',
    text2: "How to determine your Mac computer's chip type?",
    text4: '*If you cannot confirm the chip version, you can directly download the Intel version.',
    macIntel: 'Download the Intel chip version',
    macM1: 'Download the Apple chip version',
    aboutLeft: '1. Click the Apple menu in the upper left corner and select ',
    about: 'About This Mac',
    aboutRight: '',
    gaishuLeft: '2. In the',
    gaishu: ' Processor',
    chuliqiLeft: ' column on the',
    chuliqi: ' Overview page',
    typeLeft: ', check whether the',
    type: ' chip type',
    intelLeft: ' is "',
    intel: 'Intel',
    appleLeft: '" or "',
    apple: 'Apple',
    appleRight: '"，and select the corresponding version to download.',
    img1: require('../assets/M1/img1_en.png'),
    img2: require('../assets/M1/img2_en.png'),
    img3: require('../assets/M1/img3_en.png'),
  }
}
